import { Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../helper/PermissionContext";
import AccessDenied from "../pages/AccessDenied/AccessDenied";

const ROUTE_PERMISSIONS = {
  "/": "dashboard",
  "/author": "blog-management",
  "/category": "blog-management",
  "/tag": "blog-management",
  "/blog": "blog-management",
  "/add-blog": "blog-management",
  "/edit-blog": "blog-management",
  "/project": "project-management",
  "/add-project": "project-management",
  "/edit-project": "project-management",
  "/project-category": "project-management",
  "/product": "product-management",
  "/add-product": "product-management",
  "/edit-product": "product-management",
  "/product-category": "product-management",
  "/add-product-category": "product-management",
  "/edit-product-category": "product-management",
  "/news": "news-management",
  "/add-news": "news-management",
  "/edit-news": "news-management",
  "/dynamic": "dynamic-page",
  "/add-dynamic": "dynamic-page",
  "/edit-dynamic": "dynamic-page",
  "/seo": "seo-management",
  "/add-seo": "seo-management",
  "/edit-seo": "seo-management",
  "/sitemap": "sitemap",
  "/global-seo": "global-seo",
  "/schema-management": "global-seo",
  "/llms": "llms-management",
  "/robots": "robots-management",
  "/email-management": "email-management",
  "/add-email-management": "email-management",
  "/edit-email-management": "email-management",
  "/faq": "faq-management",
  "/add-faq": "faq-management",
  "/edit-faq": "faq-management",
  "/contact": "contact-us",
  "/career": "career",
  "/users": "user-management",
  "/roles": "user-management",
  "/permissions": "user-management",
};

const permissionForPath = (pathname) => {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return ROUTE_PERMISSIONS["/"];

  for (const [key, slug] of Object.entries(ROUTE_PERMISSIONS)) {
    if (key === "/") continue;
    const keySegments = key.split("/").filter(Boolean);
    if (keySegments.every((segment, index) => segments[index] === segment)) return slug;
  }

  return null;
};

export default function RoutePermissionGuard() {
  const { pathname } = useLocation();
  const { status, hasPermission } = usePermissions();
  const required = permissionForPath(pathname);

  if (status === "loading") return <div>Loading...</div>;
  if (required && !hasPermission(required)) return <AccessDenied />;

  return <Outlet />;
}
